export default "__VITE_ASSET__vV4i4GVa__"